import { useEffect } from 'react';
import { useAppContext } from './AppContext';
import { SCROLL_RESTORE_PREFIX_KEY } from '../constants/commonConstants';

const useScrollRestoration = (pageName, isNotScroll = false) => {
  const key = `${SCROLL_RESTORE_PREFIX_KEY}${pageName}`;
  const { loading } = useAppContext();

useEffect(() => {
  // console.log('Scroll call')
  if (loading || isNotScroll || !pageName) return;

  let timeoutId;

    const handleScroll = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        if (loading) return;
        // console.log('setItem scroll', key, window.scrollY.toString())
        sessionStorage.setItem(key, window.scrollY.toString());
      }, 100);
    };

  window.addEventListener('scroll', handleScroll);
  return () => {
    window.removeEventListener('scroll', handleScroll);
  };
}, [pageName, isNotScroll, loading]);

// Restore scroll on mount
useEffect(() => {
  if (loading || isNotScroll || !pageName) return;
  const saved = sessionStorage.getItem(key);
  if (saved !== null) {
    setTimeout(() => {
      if (loading) return;
      // console.log('Scroll..............', saved)
      window.scrollTo({
        top: parseInt(saved, 10),
        behavior: 'auto',
      });
    }, 200); // Ensure DOM is ready
  }
}, [loading, isNotScroll, pageName]);
};

export default useScrollRestoration;


